module.exports = __webpack_public_path__ + "static/img/foreground.a2aee54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foreground.png
// module id = OL+H
// module chunks = 0